import type { IconSvgObject } from './types';

const PinLocation01Icon: IconSvgObject = [
  ["circle", { cx: "12", cy: "7", r: "4", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 11L12 18", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M15.847 16C17.4943 18.113 18.3179 19.1695 17.8865 20.006C17.8466 20.0832 17.7999 20.1578 17.7469 20.229C17.1723 21 15.6875 21 12.7178 21H11.2822C8.31251 21 6.82765 21 6.25311 20.229C6.20005 20.1578 6.15339 20.0832 6.11355 20.006C5.68206 19.1695 6.50571 18.113 8.15301 16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default PinLocation01Icon;
